import axios from 'axios';
import { UserRegistrationForm } from '../../investors/models/userModel';

const loadAbort = () => {
    return new AbortController();
};

export const createProperEndpoint = (
    form: UserRegistrationForm,
    token: string = '',
) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'post',
                url: `${urlService}/user/v1/admin/internal-users/proper`,
                data: JSON.stringify(form),
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }),
        controller,
    };
};

export const getPropersEndpoint = (token: string) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'get',
                url: `${urlService}/user/v1/admin/propers`,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }),
        controller,
    };
}

export const deactivateProperEndpoint = (userId: string, token: string) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'delete',
                url: `${urlService}/user/v1/admin/proper/${userId}/deactivate`,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }),
        controller,
    };
}

export const activateProperEndpoint = (userId: string, token: string) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'put',
                url: `${urlService}/user/v1/admin/proper/${userId}/activate`,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }),
        controller,
    };
}

export const updateProperPasswordEndpoint = (userId: string, newPassword: string, token: string) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'put',
                url: `${urlService}/user/v1/admin/proper/${userId}/change-password`,
                data: JSON.stringify({ password: newPassword }),
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }),
        controller,
    };
}